<script lang="ts" module>
  import CardLoading from '@/ui/elements/card/CardLoading.svelte';

  export interface VersionScoreProps {
    score: number;
    loading?: boolean;
  }
</script>

<script lang="ts">
  let { ...props }: VersionScoreProps = $props();
</script>

<div
  class="flex size-8 items-center justify-center rounded-sm bg-info p-1 font-sans text-md font-semibold text-c-base"
>
  {#if props.loading}
    <CardLoading></CardLoading>
  {:else}
    {props.score}
  {/if}
</div>
